class CartDrawerController {
  constructor() {
    this.drawer = document.querySelector('[data-cart-drawer]');
    if (!this.drawer) return;

    this.panel = this.drawer.querySelector('.cart-drawer__panel');
    this.body = this.drawer.querySelector('[data-cart-drawer-body]');
    this.footer = this.drawer.querySelector('[data-cart-drawer-footer]');
    this.promo = this.drawer.querySelector('[data-cart-drawer-promo]');

    this.liveRegion = this.drawer.querySelector(
      '[data-cart-drawer-live-region]'
    );

    this.drawerCount = this.drawer.querySelector(
      '[data-cart-drawer-count]'
    );

    this.subtotalNode = this.drawer.querySelector(
      '[data-cart-drawer-subtotal]'
    );

    this.checkoutTotalNode = this.drawer.querySelector(
      '[data-cart-drawer-checkout-total]'
    );


    /* ==========================================
       SAVINGS
    ========================================== */

    this.savingsBreakdown = this.drawer.querySelector(
      '[data-cart-drawer-savings-breakdown]'
    );

    this.saleSavingsNode = this.drawer.querySelector(
      '[data-cart-drawer-sale-savings]'
    );

    this.orderDiscountRow = this.drawer.querySelector(
      '[data-cart-drawer-order-discount-row]'
    );

    this.orderDiscountLabel = this.drawer.querySelector(
      '[data-cart-drawer-order-discount-label]'
    );

    this.orderDiscountNode = this.drawer.querySelector(
      '[data-cart-drawer-order-discount]'
    );

    this.totalSavingsNode = this.drawer.querySelector(
      '[data-cart-drawer-total-savings]'
    );


    /* ==========================================
       REWARDS
    ========================================== */

    this.rewardTrack = this.drawer.querySelector(
      '[data-cart-drawer-reward-track]'
    );

    this.unlockedStatus = this.drawer.querySelector(
      '[data-cart-drawer-unlocked-status]'
    );

    this.rewardSteps = [
      ...this.drawer.querySelectorAll('[data-reward-threshold]')
    ];


    /* ==========================================
       TIMER
    ========================================== */

    this.timerNode = this.drawer.querySelector(
      '[data-cart-drawer-timer]'
    );

    this.timerDuration =
      15 * 60 * 1000;

    this.timerStorageKey =
      'elleryMayCartTimerDeadline15';

    this.timerInterval = null;


    /* ==========================================
       GLOBAL CART NODES
    ========================================== */

    this.countNodes = [
      ...document.querySelectorAll('[data-cart-count]')
    ];

    this.toggleNodes = [
      ...document.querySelectorAll('[data-cart-toggle]')
    ];

    this.currency =
      this.drawer.dataset.cartCurrency || 'GBP';

    this.variantCompareAtPrices =
      this.parseVariantCompareAtPrices();

    this.activeAddButton = null;
    this.activeAddLabel = null;
    this.activeAddLabelText = '';

    this.lastActiveElement = null;

    this.pendingItemKeys = new Set();

    this.isRefreshing = false;

    this.inertedElements = [];


    /* ==========================================
       LABELS
    ========================================== */

    this.closeLabel =
      this.drawer.dataset.cartDrawerCloseLabel || 'Close cart';

    this.emptyTitle =
      this.drawer.dataset.cartDrawerEmptyTitle || 'Your bag is empty';

    this.emptyCopy =
      this.drawer.dataset.cartDrawerEmptyCopy || '';

    this.continueUrl =
      this.drawer.dataset.cartDrawerContinueUrl || '/collections/all';

    this.continueLabel =
      this.drawer.dataset.cartDrawerContinueLabel || 'Continue shopping';

    this.decreaseQuantityLabel =
      this.drawer.dataset.cartDrawerDecreaseLabel || 'Decrease quantity';

    this.increaseQuantityLabel =
      this.drawer.dataset.cartDrawerIncreaseLabel || 'Increase quantity';

    this.quantityLabel =
      this.drawer.dataset.cartDrawerQuantityLabel || 'Quantity';

    this.removeLabel =
      this.drawer.dataset.cartDrawerRemoveLabel || 'Remove';

    this.liveRegionTemplate =
      this.drawer.dataset.cartDrawerLiveTemplate || '';

    this.addingLabel =
      this.drawer.dataset.cartDrawerAddingLabel || 'Adding...';

    this.loadingLabel =
      this.drawer.dataset.cartDrawerLoadingLabel || 'Loading your bag';


    /* ==========================================
       CLEAN UP OLD ELEMENTS
    ========================================== */

    this.removeLegacyBlocks();


    /* ==========================================
       FIX TIMER + REWARD STYLING
    ========================================== */

    this.ensureCartStyles();


    /* ==========================================
       EVENTS
    ========================================== */

    this.bindUI();


    const initialCount =
      Number(
        document.querySelector('[data-cart-count]')?.textContent || 0
      );


    this.updateRewardState(initialCount);


    if (initialCount === 0) {
      this.resetTimer();
    }
  }


  /* ==========================================
     REMOVE OLD ELEMENTS
  ========================================== */

  removeLegacyBlocks() {
    const oldRewardMessage =
      this.drawer.querySelector(
        '[data-cart-drawer-reward-message]'
      );

    if (oldRewardMessage) {
      oldRewardMessage.remove();
    }


    const trustBlock =
      this.drawer.querySelector(
        '.cart-drawer__trust'
      );

    if (trustBlock) {
      trustBlock.remove();
    }
  }


  /* ==========================================
     TIMER / MESSAGE STYLES
  ========================================== */

  ensureCartStyles() {
    if (
      document.querySelector(
        '[data-ellery-cart-fixes]'
      )
    ) {
      return;
    }


    const style =
      document.createElement('style');


    style.setAttribute(
      'data-ellery-cart-fixes',
      ''
    );


    style.textContent = `
      .cart-drawer__reservation {
        width: 100%;
        min-height: 48px;

        display: flex;
        align-items: center;
        justify-content: center;

        gap: 8px;

        padding: 11px 18px;

        box-sizing: border-box;

        background: #171717;
        color: #ffffff;

        text-align: center;
      }


      .cart-drawer__reservation > span {
        display: inline;

        color: #ffffff;

        font-size: 12px;
        font-weight: 400;

        line-height: 1.45;

        letter-spacing: 0;
      }


      .cart-drawer__reservation-time {
        color: #ffffff !important;

        font-size: 13px !important;
        font-weight: 700 !important;

        letter-spacing: 0 !important;

        font-variant-numeric: tabular-nums;
      }


      .cart-drawer__reservation-icon {
        width: 17px !important;
        height: 17px !important;

        min-width: 17px;
        max-width: 17px;

        flex: 0 0 17px;

        display: block;

        fill: none !important;

        stroke: currentColor !important;
        stroke-width: 1.7 !important;
        stroke-linecap: round;
        stroke-linejoin: round;

        color: #ffffff;
      }


      .cart-drawer__reservation-icon circle,
      .cart-drawer__reservation-icon path {
        fill: none !important;

        stroke: currentColor !important;
      }


      .cart-drawer__free-delivery {
        margin:
          0
          0
          16px;

        color: #272421;

        font-size: 11px;
        font-weight: 600;

        line-height: 1.4;

        letter-spacing: 0.1px;

        text-align: center;

        text-transform: none;
      }


      @media screen and (max-width: 767px) {
        .cart-drawer__reservation {
          min-height: 46px;

          padding:
            10px
            14px;

          gap: 7px;
        }


        .cart-drawer__reservation > span {
          font-size: 11px;
        }


        .cart-drawer__reservation-time {
          font-size: 12px !important;
        }


        .cart-drawer__reservation-icon {
          width: 16px !important;
          height: 16px !important;

          min-width: 16px;
          max-width: 16px;

          flex-basis: 16px;
        }


        .cart-drawer__free-delivery {
          margin-bottom: 15px;

          font-size: 10px;

          line-height: 1.4;
        }
      }
    `;


    document.head.appendChild(style);
  }


  /* ==========================================
     BIND UI
  ========================================== */

  bindUI() {
    this.toggleNodes.forEach((trigger) => {
      trigger.setAttribute(
        'aria-haspopup',
        'dialog'
      );

      trigger.setAttribute(
        'aria-expanded',
        'false'
      );


      trigger.addEventListener(
        'click',
        async (event) => {
          event.preventDefault();

          this.lastActiveElement =
            trigger;

          await this.refresh();

          this.open();
        }
      );
    });


    this.drawer
      .querySelectorAll(
        '[data-cart-drawer-close]'
      )
      .forEach((button) => {
        button.addEventListener(
          'click',
          () => this.close()
        );
      });


    document.addEventListener(
      'keydown',
      (event) => {
        if (
          event.key === 'Escape' &&
          this.drawer.classList.contains('is-open')
        ) {
          this.close();

        } else if (
          event.key === 'Tab' &&
          this.drawer.classList.contains('is-open')
        ) {
          this.trapFocus(event);
        }
      }
    );


    document.addEventListener(
      'submit',
      (event) =>
        this.handleAddToCart(event)
    );


    this.drawer.addEventListener(
      'click',
      (event) =>
        this.handleDrawerClick(event)
    );


    this.drawer.addEventListener(
      'change',
      (event) =>
        this.handleDrawerChange(event)
    );
  }


  /* ==========================================
     ADD TO CART
  ========================================== */

  async handleAddToCart(event) {
    const form =
      event.target;


    if (
      !(form instanceof HTMLFormElement)
    ) {
      return;
    }


    if (
      !form.matches(
        '[data-product-form]'
      )
    ) {
      return;
    }


    const submitter =
      event.submitter;


    if (
      !submitter ||
      submitter.getAttribute('name') !== 'add'
    ) {
      return;
    }


    event.preventDefault();


    const formData =
      new FormData(form);


    this.activeAddButton =
      submitter;


    this.activeAddLabel =
      submitter.querySelector(
        '[data-add-to-cart-label]'
      );


    this.activeAddLabelText =
      this.activeAddLabel?.textContent || '';


    this.cacheFormVariantCompareAt(
      form
    );


    this.hideAddToCartError(
      form
    );


    try {
      this.setAddButtonState(
        true
      );


      const response =
        await fetch(
          `${window.Shopify?.routes?.root || '/'}cart/add.js`,
          {
            method: 'POST',

            headers: {
              Accept:
                'application/json'
            },

            body:
              formData
          }
        );


      if (!response.ok) {
        const data =
          await response
            .json()
            .catch(
              () => null
            );


        throw new Error(
          data?.description ||
          data?.message ||
          'Unable to add item to cart'
        );
      }


      await response.json();


      await this.refresh();


      this.open();

    } catch (error) {
      console.error(
        error
      );


      this.showAddToCartError(
        form,
        error?.message
      );

    } finally {
      this.setAddButtonState(
        false
      );
    }
  }


  showAddToCartError(
    form,
    message
  ) {
    const errorElement =
      form.querySelector(
        '[data-add-to-cart-error]'
      );


    if (!errorElement) {
      window.location.href =
        form.action || '/cart';

      return;
    }


    errorElement.textContent =
      message ||
      errorElement.dataset.genericError ||
      '';


    errorElement.hidden =
      false;
  }


  hideAddToCartError(form) {
    const errorElement =
      form.querySelector(
        '[data-add-to-cart-error]'
      );


    if (!errorElement) {
      return;
    }


    errorElement.hidden =
      true;


    errorElement.textContent =
      '';
  }


  /* ==========================================
     CART INTERACTIONS
  ========================================== */

  async handleDrawerClick(
    event
  ) {
    const quantityTrigger =
      event.target.closest(
        '[data-cart-quantity-change]'
      );


    if (quantityTrigger) {
      const item =
        quantityTrigger.closest(
          '[data-cart-item-key]'
        );


      if (!item) {
        return;
      }


      const key =
        item.dataset.cartItemKey;


      if (
        !key ||
        this.pendingItemKeys.has(key)
      ) {
        return;
      }


      const delta =
        Number(
          quantityTrigger.dataset.cartQuantityDelta ||
          0
        );


      const quantityValue =
        item.querySelector(
          '.cart-drawer__quantity-value'
        );


      const currentQuantity =
        Number(
          quantityValue?.value ??
          quantityValue?.textContent ??
          0
        );


      const nextQuantity =
        Math.max(
          0,
          currentQuantity +
          delta
        );


      await this.changeItem(
        key,
        nextQuantity
      );


      return;
    }


    const removeTrigger =
      event.target.closest(
        '[data-cart-remove]'
      );


    if (removeTrigger) {
      const item =
        removeTrigger.closest(
          '[data-cart-item-key]'
        );


      if (!item) {
        return;
      }


      const key =
        item.dataset.cartItemKey;


      if (
        !key ||
        this.pendingItemKeys.has(key)
      ) {
        return;
      }


      await this.changeItem(
        key,
        0
      );
    }
  }


  async handleDrawerChange(
    event
  ) {
    const input =
      event.target.closest(
        '[data-cart-quantity-input]'
      );


    if (!input) {
      return;
    }


    const item =
      input.closest(
        '[data-cart-item-key]'
      );


    if (!item) {
      return;
    }


    const key =
      item.dataset.cartItemKey;


    if (
      !key ||
      this.pendingItemKeys.has(key)
    ) {
      return;
    }


    const quantity =
      Math.max(
        0,
        Number(
          input.value
        ) || 0
      );


    await this.changeItem(
      key,
      quantity
    );
  }


  async changeItem(
    key,
    quantity
  ) {
    if (
      !key ||
      this.pendingItemKeys.has(key)
    ) {
      return;
    }


    this.pendingItemKeys.add(
      key
    );


    this.setItemPendingState(
      key,
      true
    );


    try {
      const response =
        await fetch(
          `${window.Shopify?.routes?.root || '/'}cart/change.js`,
          {
            method:
              'POST',

            headers: {
              'Content-Type':
                'application/json',

              Accept:
                'application/json'
            },

            body:
              JSON.stringify({
                id:
                  key,

                quantity:
                  quantity
              })
          }
        );


      if (!response.ok) {
        throw new Error(
          'Unable to update cart item'
        );
      }


      const cart =
        await response.json();


      this.render(
        cart
      );

    } catch (error) {
      console.error(
        error
      );


      this.pendingItemKeys.delete(
        key
      );


      await this.refresh();

    } finally {
      this.pendingItemKeys.delete(
        key
      );


      this.setItemPendingState(
        key,
        false
      );
    }
  }


  /* ==========================================
     SKELETON
  ========================================== */

  showSkeleton(count = 2) {
    if (!this.body) {
      return;
    }


    const items =
      Array.from(
        {
          length:
            count
        },
        () => `
          <div
            class="cart-drawer__skeleton-item"
            aria-hidden="true"
          >
            <div
              class="cart-drawer__skeleton-media"
            ></div>

            <div
              class="cart-drawer__skeleton-lines"
            >
              <div
                class="cart-drawer__skeleton-line"
              ></div>

              <div
                class="cart-drawer__skeleton-line"
              ></div>

              <div
                class="cart-drawer__skeleton-line"
              ></div>
            </div>
          </div>
        `
      )
      .join('');


    this.body.innerHTML = `
      <div
        class="cart-drawer__skeleton"
        aria-busy="true"
        aria-label="${this.escapeHtml(this.loadingLabel)}"
      >
        ${items}
      </div>
    `;
  }


  /* ==========================================
     REFRESH CART
  ========================================== */

  async refresh() {
    if (this.isRefreshing) {
      return null;
    }


    this.isRefreshing =
      true;


    const currentCount =
      Number(
        document.querySelector(
          '[data-cart-count]'
        )?.textContent ||
        0
      );


    if (
      currentCount >
      0
    ) {
      this.showSkeleton(
        Math.min(
          currentCount,
          3
        )
      );
    }


    try {
      const response =
        await fetch(
          `${window.Shopify?.routes?.root || '/'}cart.js`,
          {
            headers: {
              Accept:
                'application/json'
            }
          }
        );


      const cart =
        await response.json();


      this.render(
        cart
      );


      return cart;

    } finally {
      this.isRefreshing =
        false;
    }
  }


  /* ==========================================
     RENDER CART
  ========================================== */

  render(cart) {
    this.hydrateCompareAtPrices(
      cart
    );


    const itemCount =
      Number(
        cart.item_count ||
        0
      );


    this.removeLegacyBlocks();


    this.countNodes =
      [
        ...document.querySelectorAll(
          '[data-cart-count]'
        )
      ];


    this.countNodes.forEach(
      (node) => {
        node.textContent =
          itemCount;


        node.hidden =
          itemCount ===
          0;
      }
    );


    if (
      this.drawerCount
    ) {
      this.drawerCount.textContent =
        itemCount;
    }


    if (
      this.subtotalNode
    ) {
      this.subtotalNode.textContent =
        this.formatMoney(
          cart.total_price ||
          0
        );
    }


    if (
      this.checkoutTotalNode
    ) {
      this.checkoutTotalNode.textContent =
        this.formatMoney(
          cart.total_price ||
          0
        );
    }


    if (
      this.liveRegion
    ) {
      this.liveRegion.textContent =
        this.liveRegionTemplate
          .replace(
            '[[count]]',
            String(
              itemCount
            )
          )
          .replace(
            '[[subtotal]]',
            this.formatMoney(
              cart.total_price ||
              0
            )
          );
    }


    if (
      this.footer
    ) {
      this.footer.hidden =
        itemCount ===
        0;
    }


    if (
      this.promo
    ) {
      this.promo.hidden =
        itemCount ===
        0;
    }


    this.updateRewardState(
      itemCount
    );


    /* ==========================================
       EMPTY CART
    ========================================== */

    if (!itemCount) {
      this.resetTimer();


      if (
        this.savingsBreakdown
      ) {
        this.savingsBreakdown.hidden =
          true;
      }


      this.body.innerHTML = `
        <div
          class="cart-drawer__empty"
          data-cart-drawer-empty
        >

          <p
            class="cart-drawer__empty-title"
          >
            ${this.escapeHtml(this.emptyTitle)}
          </p>


          <p
            class="cart-drawer__empty-copy"
          >
            ${this.escapeHtml(this.emptyCopy)}
          </p>


          <a
            href="${this.escapeHtml(this.continueUrl)}"
            class="cart-drawer__empty-cta"
          >
            ${this.escapeHtml(this.continueLabel)}
          </a>

        </div>
      `;


      return;
    }


    /* ==========================================
       PRODUCT / SALE SAVINGS
    ========================================== */

    let saleSavingsTotal =
      0;


    const itemsMarkup =
      (cart.items || [])
        .map(
          (item) => {

            const finalLinePrice =
              Number(
                item.final_line_price ||
                0
              );


            const originalLinePrice =
              Number(
                item.original_line_price ||
                finalLinePrice
              );


            const compareLinePrice =
              Number(
                item.compare_at_line_price ||
                0
              );


            const saleSaving =
              compareLinePrice >
              originalLinePrice
                ? Math.max(
                    0,
                    compareLinePrice -
                    originalLinePrice
                  )
                : 0;


            saleSavingsTotal +=
              saleSaving;


            const referenceLinePrice =
              compareLinePrice >
              originalLinePrice
                ? compareLinePrice
                : originalLinePrice;


            const imageUrl =
              item.image
                ? `${item.image}${item.image.includes('?') ? '&' : '?'}width=320&height=400&crop=center`
                : '';


            const imageMarkup =
              item.image
                ? `
                  <a
                    href="${this.escapeHtml(item.url)}"
                    class="cart-drawer__item-media"
                  >
                    <img
                      src="${this.escapeHtml(imageUrl)}"
                      alt="${this.escapeHtml(item.product_title)}"
                      class="cart-drawer__item-image"
                      width="320"
                      height="400"
                      loading="lazy"
                    >
                  </a>
                `
                : `
                  <div
                    class="cart-drawer__item-media"
                  ></div>
                `;


            const optionsMarkup =
              this.renderOptions(
                item
              );


            const compareMarkup =
              referenceLinePrice >
              finalLinePrice
                ? `
                  <span
                    class="cart-drawer__item-compare-price"
                  >
                    ${this.formatMoney(referenceLinePrice)}
                  </span>
                `
                : '';


            const savingMarkup =
              saleSaving >
              0
                ? `
                  <span
                    class="cart-drawer__item-saving"
                  >
                    SAVE ${this.formatMoney(saleSaving)}
                  </span>
                `
                : '';


            const isPending =
              this.pendingItemKeys.has(
                item.key
              );


            return `
              <li
                class="cart-drawer__item${isPending ? ' is-pending' : ''}"
                data-cart-item-key="${this.escapeHtml(item.key)}"
                aria-busy="${isPending ? 'true' : 'false'}"
              >

                ${imageMarkup}


                <div
                  class="cart-drawer__item-content"
                >

                  <div
                    class="cart-drawer__item-heading"
                  >

                    <a
                      href="${this.escapeHtml(item.url)}"
                      class="cart-drawer__item-title"
                    >
                      ${this.escapeHtml(item.product_title)}
                    </a>


                    <button
                      type="button"
                      class="cart-drawer__remove"
                      data-cart-remove
                      ${isPending ? 'disabled' : ''}
                      aria-label="${this.escapeHtml(this.removeLabel)}: ${this.escapeHtml(item.product_title)}"
                    >
                      ${this.escapeHtml(this.removeLabel)}
                    </button>

                  </div>


                  ${optionsMarkup}


                  <div
                    class="cart-drawer__item-prices"
                  >

                    ${compareMarkup}


                    <span
                      class="cart-drawer__item-price"
                    >
                      ${this.formatMoney(finalLinePrice)}
                    </span>


                    ${savingMarkup}

                  </div>


                  <div
                    class="cart-drawer__item-bottom"
                  >

                    <div
                      class="cart-drawer__quantity"
                    >

                      <button
                        type="button"
                        class="cart-drawer__quantity-button"
                        data-cart-quantity-change
                        data-cart-quantity-delta="-1"
                        aria-label="${this.escapeHtml(this.decreaseQuantityLabel)}"
                        ${isPending ? 'disabled' : ''}
                      >
                        −
                      </button>


                      <input
                        type="number"
                        class="cart-drawer__quantity-value"
                        value="${Number(item.quantity || 1)}"
                        min="1"
                        aria-label="${this.escapeHtml(this.quantityLabel)}"
                        data-cart-quantity-input
                        ${isPending ? 'disabled' : ''}
                      >


                      <button
                        type="button"
                        class="cart-drawer__quantity-button"
                        data-cart-quantity-change
                        data-cart-quantity-delta="1"
                        aria-label="${this.escapeHtml(this.increaseQuantityLabel)}"
                        ${isPending ? 'disabled' : ''}
                      >
                        +
                      </button>

                    </div>

                  </div>

                </div>

              </li>
            `;
          }
        )
        .join('');


    this.body.innerHTML = `
      <ul
        class="cart-drawer__items"
        data-cart-drawer-items
        role="list"
      >
        ${itemsMarkup}
      </ul>
    `;


    /* ==========================================
       EXTRA ORDER DISCOUNT
    ========================================== */

    const itemsSubtotal =
      Number(
        cart.items_subtotal_price ||
        0
      );


    const cartTotal =
      Number(
        cart.total_price ||
        0
      );


    const orderDiscountTotal =
      Math.max(
        0,
        itemsSubtotal -
        cartTotal
      );


    /* ==========================================
       TOTAL SAVINGS
    ========================================== */

    const totalSavingsAmount =
      saleSavingsTotal +
      orderDiscountTotal;


    if (
      this.savingsBreakdown
    ) {
      this.savingsBreakdown.hidden =
        totalSavingsAmount <=
        0;
    }


    if (
      this.saleSavingsNode
    ) {
      this.saleSavingsNode.textContent =
        this.formatMoney(
          saleSavingsTotal
        );
    }


    if (
      this.orderDiscountRow
    ) {
      this.orderDiscountRow.hidden =
        orderDiscountTotal <=
        0;
    }


    if (
      this.orderDiscountNode
    ) {
      this.orderDiscountNode.textContent =
        this.formatMoney(
          orderDiscountTotal
        );
    }


    /* ==========================================
       CORRECT TIER LABEL
    ========================================== */

    let rewardPercent =
      0;


    if (
      itemCount >=
      5
    ) {
      rewardPercent =
        25;

    } else if (
      itemCount >=
      4
    ) {
      rewardPercent =
        20;

    } else if (
      itemCount >=
      3
    ) {
      rewardPercent =
        15;

    } else if (
      itemCount >=
      2
    ) {
      rewardPercent =
        10;
    }


    if (
      this.orderDiscountLabel
    ) {
      this.orderDiscountLabel.textContent =
        rewardPercent >
        0
          ? `EXTRA ${rewardPercent}% ORDER DISCOUNT`
          : 'ORDER DISCOUNT';
    }


    if (
      this.totalSavingsNode
    ) {
      this.totalSavingsNode.textContent =
        this.formatMoney(
          totalSavingsAmount
        );
    }


    if (
      this.drawer.classList.contains(
        'is-open'
      )
    ) {
      this.startTimer();
    }
  }


  /* ==========================================
     PRODUCT OPTIONS
  ========================================== */

  renderOptions(item) {
    const options =
      Array.isArray(
        item.options_with_values
      )
        ? item.options_with_values
        : [];


    if (
      options.length
    ) {
      return `
        <p
          class="cart-drawer__item-options"
        >
          ${options
            .map(
              (option) => `
                <span>
                  <strong>
                    ${this.escapeHtml(option.name)}:
                  </strong>

                  ${this.escapeHtml(option.value)}
                </span>
              `
            )
            .join(
              '<span class="cart-drawer__option-separator">·</span>'
            )}
        </p>
      `;
    }


    if (
      item.variant_title &&
      item.variant_title !==
      'Default Title'
    ) {
      return `
        <p
          class="cart-drawer__item-options"
        >
          ${this.escapeHtml(item.variant_title)}
        </p>
      `;
    }


    return '';
  }


  /* ==========================================
     REWARD STATE
  ========================================== */

  updateRewardState(
    itemCount
  ) {
    let progress =
      0;


    if (
      itemCount >=
      5
    ) {
      progress =
        100;

    } else if (
      itemCount >=
      4
    ) {
      progress =
        75;

    } else if (
      itemCount >=
      3
    ) {
      progress =
        50;

    } else if (
      itemCount >=
      2
    ) {
      progress =
        25;
    }


    /* PROGRESS BAR */

    if (
      this.rewardTrack
    ) {
      this.rewardTrack.style.setProperty(
        '--reward-progress',
        `${progress}%`
      );
    }


    /* ACTIVE REWARD CIRCLES */

    this.rewardSteps.forEach(
      (step) => {
        const threshold =
          Number(
            step.dataset.rewardThreshold ||
            0
          );


        step.classList.toggle(
          'is-active',
          itemCount >=
          threshold
        );
      }
    );


    /* ==========================================
       MESSAGE ABOVE REWARD BAR
    ========================================== */

    if (
      this.unlockedStatus
    ) {
      let unlockedText =
        '';


      if (
        itemCount >=
        5
      ) {
        unlockedText =
          '25% discount unlocked on your order!';

      } else if (
        itemCount ===
        4
      ) {
        unlockedText =
          '20% discount unlocked! Add 1 more item to unlock 25% on your order!';

      } else if (
        itemCount ===
        3
      ) {
        unlockedText =
          '15% discount unlocked! Add 1 more item to unlock 20% on your order!';

      } else if (
        itemCount ===
        2
      ) {
        unlockedText =
          '10% discount unlocked! Add 1 more item to unlock 15% on your order!';

      } else {
        unlockedText =
          'Add 1 more item to unlock the 10% discount on your order!';
      }


      this.unlockedStatus.textContent =
        unlockedText;
    }
  }


  /* ==========================================
     TIMER
  ========================================== */

  startTimer() {
    this.timerNode =
      this.drawer.querySelector(
        '[data-cart-drawer-timer]'
      );


    if (
      !this.timerNode
    ) {
      return;
    }


    clearInterval(
      this.timerInterval
    );


    let deadline =
      Number(
        localStorage.getItem(
          this.timerStorageKey
        ) ||
        0
      );


    /*
      Only create a new countdown
      when there is no deadline stored.

      This prevents the timer from
      resetting every time the cart opens.
    */

    if (!deadline) {
      deadline =
        Date.now() +
        this.timerDuration;


      localStorage.setItem(
        this.timerStorageKey,
        String(
          deadline
        )
      );
    }


    const update =
      () => {

        const remaining =
          Math.max(
            0,
            deadline -
            Date.now()
          );


        const totalSeconds =
          Math.ceil(
            remaining /
            1000
          );


        const minutes =
          Math.floor(
            totalSeconds /
            60
          );


        const seconds =
          totalSeconds %
          60;


        this.timerNode.textContent =
          `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;


        if (
          remaining <=
          0
        ) {
          clearInterval(
            this.timerInterval
          );


          this.timerInterval =
            null;


          this.timerNode.textContent =
            '00:00';
        }
      };


    update();


    if (
      deadline >
      Date.now()
    ) {
      this.timerInterval =
        window.setInterval(
          update,
          1000
        );
    }
  }


  resetTimer() {
    clearInterval(
      this.timerInterval
    );


    this.timerInterval =
      null;


    localStorage.removeItem(
      this.timerStorageKey
    );


    this.timerNode =
      this.drawer.querySelector(
        '[data-cart-drawer-timer]'
      );


    if (
      this.timerNode
    ) {
      this.timerNode.textContent =
        '15:00';
    }
  }


  /* ==========================================
     ACCESSIBILITY / INERT
  ========================================== */

  setBackgroundInert(
    isInert
  ) {
    if (
      isInert
    ) {
      this.inertedElements =
        [
          ...document.body.children
        ]
          .filter(
            (element) =>
              element !==
              this.drawer &&
              element.tagName !==
              'SCRIPT' &&
              !element.hasAttribute(
                'inert'
              )
          );


      this.inertedElements.forEach(
        (element) =>
          element.setAttribute(
            'inert',
            ''
          )
      );

    } else {
      (
        this.inertedElements ||
        []
      )
        .forEach(
          (element) =>
            element.removeAttribute(
              'inert'
            )
        );


      this.inertedElements =
        [];
    }
  }


  /* ==========================================
     OPEN
  ========================================== */

  open() {
    this.removeLegacyBlocks();


    this.drawer.classList.add(
      'is-open'
    );


    this.drawer.setAttribute(
      'aria-hidden',
      'false'
    );


    document.body.classList.add(
      'cart-drawer-open'
    );


    this.toggleNodes.forEach(
      (node) =>
        node.setAttribute(
          'aria-expanded',
          'true'
        )
    );


    this.setBackgroundInert(
      true
    );


    const itemCount =
      Number(
        document.querySelector(
          '[data-cart-count]'
        )?.textContent ||
        0
      );


    this.updateRewardState(
      itemCount
    );


    if (
      itemCount >
      0
    ) {
      this.startTimer();
    }


    const focusTarget =
      this.panel.querySelector(
        '#CartDrawerTitle'
      ) ||
      this.panel.querySelector(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );


    focusTarget?.focus();
  }


  /* ==========================================
     CLOSE
  ========================================== */

  close() {
    this.drawer.classList.remove(
      'is-open'
    );


    this.drawer.setAttribute(
      'aria-hidden',
      'true'
    );


    document.body.classList.remove(
      'cart-drawer-open'
    );


    this.toggleNodes.forEach(
      (node) =>
        node.setAttribute(
          'aria-expanded',
          'false'
        )
    );


    this.setBackgroundInert(
      false
    );


    clearInterval(
      this.timerInterval
    );


    this.timerInterval =
      null;


    this.lastActiveElement?.focus();
  }


  /* ==========================================
     ADD BUTTON STATE
  ========================================== */

  setAddButtonState(
    isLoading
  ) {
    if (
      !this.activeAddButton
    ) {
      return;
    }


    this.activeAddButton.disabled =
      isLoading;


    if (
      this.activeAddLabel
    ) {
      this.activeAddLabel.textContent =
        isLoading
          ? this.addingLabel
          : this.activeAddLabelText;
    }
  }


  /* ==========================================
     ITEM PENDING
  ========================================== */

  setItemPendingState(
    key,
    isPending
  ) {
    const item =
      this.body?.querySelector(
        `[data-cart-item-key="${CSS.escape(key)}"]`
      );


    if (!item) {
      return;
    }


    item.classList.toggle(
      'is-pending',
      isPending
    );


    item.setAttribute(
      'aria-busy',
      isPending
        ? 'true'
        : 'false'
    );


    item
      .querySelectorAll(
        'button, input'
      )
      .forEach(
        (element) => {
          element.disabled =
            isPending;
        }
      );
  }


  /* ==========================================
     FOCUS TRAP
  ========================================== */

  trapFocus(event) {
    const focusableNodes =
      [
        ...this.panel.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        )
      ]
      .filter(
        (node) =>
          !node.hasAttribute(
            'disabled'
          )
      );


    if (
      !focusableNodes.length
    ) {
      return;
    }


    const firstNode =
      focusableNodes[0];


    const lastNode =
      focusableNodes[
        focusableNodes.length -
        1
      ];


    if (
      event.shiftKey &&
      document.activeElement ===
      firstNode
    ) {
      event.preventDefault();


      lastNode.focus();

    } else if (
      !event.shiftKey &&
      document.activeElement ===
      lastNode
    ) {
      event.preventDefault();


      firstNode.focus();
    }
  }


  /* ==========================================
     MONEY
  ========================================== */

  formatMoney(cents) {
    const locale =
      this.currency ===
      'GBP'
        ? 'en-GB'
        : document.documentElement.lang ||
          'en-GB';


    return new Intl.NumberFormat(
      locale,
      {
        style:
          'currency',

        currency:
          this.currency,

        minimumFractionDigits:
          2,

        maximumFractionDigits:
          2
      }
    )
      .format(
        Number(
          cents ||
          0
        ) /
        100
      );
  }


  /* ==========================================
     ESCAPE HTML
  ========================================== */

  escapeHtml(value) {
    return String(
      value ||
      ''
    )
      .replaceAll(
        '&',
        '&amp;'
      )
      .replaceAll(
        '<',
        '&lt;'
      )
      .replaceAll(
        '>',
        '&gt;'
      )
      .replaceAll(
        '"',
        '&quot;'
      )
      .replaceAll(
        "'",
        '&#39;'
      );
  }


  /* ==========================================
     JSON
  ========================================== */

  parseJsonNode(selector) {
    const node =
      this.drawer.querySelector(
        selector
      );


    if (!node) {
      return null;
    }


    try {
      return JSON.parse(
        node.textContent ||
        '{}'
      );

    } catch (error) {
      console.error(
        error
      );


      return null;
    }
  }


  /* ==========================================
     COMPARE AT PRICES
  ========================================== */

  parseVariantCompareAtPrices() {
    const value =
      this.parseJsonNode(
        '[data-cart-drawer-compare-at-prices]'
      );


    const prices =
      new Map();


    Object.entries(
      value ||
      {}
    )
      .forEach(
        (
          [
            variantId,
            compareAtPrice
          ]
        ) => {

          const normalizedId =
            Number(
              variantId
            );


          if (
            !normalizedId
          ) {
            return;
          }


          prices.set(
            normalizedId,
            Number(
              compareAtPrice ||
              0
            )
          );
        }
      );


    return prices;
  }


  cacheFormVariantCompareAt(
    form
  ) {
    const variantId =
      Number(
        form.querySelector(
          '[name="id"]'
        )?.value ||
        0
      );


    if (
      !variantId ||
      this.variantCompareAtPrices.has(
        variantId
      )
    ) {
      return;
    }


    const productJsonNode =
      form
        .closest(
          '[data-product-section]'
        )
        ?.querySelector(
          '[data-product-json]'
        );


    if (
      !productJsonNode
    ) {
      return;
    }


    try {
      const product =
        JSON.parse(
          productJsonNode.textContent ||
          '{}'
        );


      const variant =
        (
          product.variants ||
          []
        )
          .find(
            (item) =>
              Number(
                item.id
              ) ===
              variantId
          );


      if (
        !variant
      ) {
        return;
      }


      this.variantCompareAtPrices.set(
        variantId,
        Number(
          variant.compare_at_price ||
          0
        )
      );

    } catch (error) {
      console.error(
        error
      );
    }
  }


  hydrateCompareAtPrices(
    cart
  ) {
    if (
      !cart?.items?.length
    ) {
      return;
    }


    cart.items.forEach(
      (item) => {

        const variantId =
          Number(
            item.variant_id ||
            0
          );


        const compareAtUnitPrice =
          Number(
            this.variantCompareAtPrices.get(
              variantId
            ) ||
            0
          );


        const currentUnitPrice =
          Number(
            item.original_price ||
            item.final_price ||
            0
          );


        item.compare_at_unit_price =
          compareAtUnitPrice;


        item.compare_at_line_price =
          compareAtUnitPrice >
          currentUnitPrice
            ? compareAtUnitPrice *
              Number(
                item.quantity ||
                0
              )
            : 0;
      }
    );
  }
}


/* ==========================================
   INITIALISE
========================================== */

document.addEventListener(
  'DOMContentLoaded',
  () => {
    new CartDrawerController();
  }
);